import React from 'react'

const TotalFeeInfoSection = ({feeDetail,userDetail}) => {
    const {course_name, class_name, country_name,session} = userDetail !==undefined && userDetail

  return (
    <>

    <div className="total_feeInfo_section mt-4">
            <div className="row">
                <div className="col-lg-6 text-center text-md-start">
                    <h2>Total Amount Payable</h2>
                    <h3>
                        {feeDetail?.scholarship_percentage > 0 && <strike className="me-2 text-dark">{feeDetail?.total_fee} {feeDetail?.currency_code}</strike>}
                        { feeDetail?.net_payable_amount} {feeDetail?.currency_code} {feeDetail?.scholarship_percentage > 0 && <span className="badge bg-green">{feeDetail?.scholarship_percentage}% Off</span> }
                        
                        {/* <div className="dropdown_feeButton ms-3" data-bs-toggle="modal" data-bs-target="#feeModal">
                            Fee Breakdown 
                            <svg width="12" style={{marginTop:'-2.5px'}} height="12" fill="currentcolor" className="bi bi-chevron-down" viewBox="0 0 15 15">
                                <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                            </svg>
                        </div> */}
                    </h3>
                </div>
                
                <div className="col-lg-6 text-center">
                    <h2 className="course_name mb-3 text-secondary fw-bold">{course_name}</h2>
                    <p className="fw-bold mb-0">Class {class_name} | Session {session} | {country_name}</p>
                </div>
            </div>
        </div>
        </>
  )
}

export default TotalFeeInfoSection